import React from 'react';
import {
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaReddit,
  FaTwitter,
  FaYoutube,
  FaGithub,
} from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import styled from 'styled-components';

const ContactHubStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  justify-content: ${(props) => props.justify || 'center'};
  align-items: center;

  --facebookColor: #3b5999;
  --instagramColor: #8e37b8;
  --redditColor: #ff4500;
  --twitterColor: #1da1f2;
  --linkedInColor: #0a66c2;
  --youTubeColor: #ff0000;
  --githubColor: #72757e;
  --emailColor: var(--linkHover);

  svg {
    transition: transform 0.2s cubic-bezier(0.65, 0, 0.35, 1);
    &:hover {
      transition: transform 0.4s cubic-bezier(0.65, 0, 0.35, 1);
      transform: translateY(-4px);
    }
  }

  a {
    font-size: 4rem;
    margin: 1.5rem;

    @media (max-width: 550px) {
      font-size: 3.55rem;
    }
  }
  .facebook-contact {
    color: var(--textColor);
    &:hover {
      color: var(--facebookColor);
    }
  }
  .instagram-contact {
    color: var(--textColor);
    &:hover {
      color: var(--instagramColor);
    }
  }
  .reddit-contact {
    color: var(--textColor);
    &:hover {
      color: var(--redditColor);
    }
  }
  .twitter-contact {
    color: var(--textColor);
    &:hover {
      color: var(--twitterColor);
    }
  }
  .linkedin-contact {
    color: var(--textColor);
    &:hover {
      color: var(--linkedInColor);
    }
  }
  .youtube-contact {
    color: var(--textColor);
    &:hover {
      color: var(--youTubeColor);
    }
  }
  .github-contact {
    color: var(--textColor);
    &:hover {
      color: var(--githubColor);
    }
  }
  .email-contact {
    color: var(--textColor);
    &:hover {
      color: var(--linkHover);
    }
  }
`;

export default function ContactHub({
  facebook,
  instagram,
  twitter,
  linkedIn,
  reddit,
  github,
  youtube,
  email,
  userNames,
  showText,
  justify,
}) {
  return (
    <>
      {showText ? <h3>Contact Information</h3> : ''}
      <ContactHubStyles justify={justify}>
        {facebook && userNames.facebook ? (
          <span>
            <a
              href={`https://www.facebook.com/${userNames.facebook}`}
              target="_blank"
              title="Contact through Facebook"
              aria-label="Contact through Facebook"
              rel="noreferrer"
            >
              <FaFacebook
                className="facebook-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {instagram && userNames.instagram ? (
          <span>
            <a
              href={`https://instagram.com/${userNames.instagram}`}
              target="_blank"
              title="Contact through Instagram"
              aria-label="Contact through Instagram"
              rel="noreferrer"
            >
              <FaInstagram
                className="instagram-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {reddit && userNames.reddit ? (
          <span>
            <a
              href={`https://www.reddit.com/u/${userNames.reddit}`}
              target="_blank"
              title="Contact through LinkedIn"
              aria-label="Contact through LinkedIn"
              rel="noreferrer"
            >
              <FaReddit
                className="reddit-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {youtube && userNames.youtube ? (
          <span>
            <a
              href={`https://www.youtube.com/user/${userNames.youtube}`}
              target="_blank"
              title="Contact through YouTube"
              aria-label="Contact through YouTube"
              rel="noreferrer"
            >
              <FaYoutube
                className="youtube-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {twitter && userNames.twitter ? (
          <span>
            <a
              href={`https://www.twitter.com/${userNames.twitter}`}
              target="_blank"
              title="Contact through Twitter"
              aria-label="Contact through Twitter"
              rel="noreferrer"
            >
              <FaTwitter
                className="twitter-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {linkedIn && userNames.linkedIn ? (
          <span>
            <a
              href={`https://www.linkedin.com/in/${userNames.linkedIn}`}
              target="_blank"
              title="Contact through LinkedIn"
              aria-label="Contact through LinkedIn"
              rel="noreferrer"
            >
              <FaLinkedin
                className="linkedin-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {github && userNames.github ? (
          <span>
            <a
              href={`https://www.github.com/${userNames.github}`}
              target="_blank"
              title="View Github"
              aria-label="View Github"
              rel="noreferrer"
            >
              <FaGithub
                className="github-contact"
                style={{ strokeWidth: 15 }}
              />
            </a>
          </span>
        ) : (
          ''
        )}
        {email && userNames.email ? (
          <span>
            <a
              href={`mailto:${userNames.email}`}
              target="_blank"
              title="Contact by email"
              aria-label="Contact by email"
              rel="noreferrer"
            >
              <FiMail className="email-contact" />
            </a>
          </span>
        ) : (
          ''
        )}
      </ContactHubStyles>
    </>
  );
}
